import React, { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { Backdrop, CircularProgress } from '@mui/material';
import { base64ToBlobUrl, getMimeTypeFromDataURI } from '../../../utils/fileHelpers';
import { useWindowSize } from '../../../utils/hooks';
import DownloadIcon from '../Icons/DownloadIcon';
import CloseButtonIcon from '../Icons/CloseButtonIcon';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import colors from '../../../scss/colors';
import classes from './CustomDocViewer.module.scss';

const SmartRenderer = ({ base64Data, mimeType, filename }) => {
  const fileUrl = React.useMemo(() => base64ToBlobUrl(base64Data, mimeType), [base64Data, mimeType]);

  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);
  if (!fileUrl) {
    return <p>Error: File data is missing or corrupted.</p>;
  }

  if (mimeType === 'application/pdf') {
    return (
      <iframe
        src={fileUrl}
        width="100%"
        title={filename}
        style={{ width: '50vw', height: '100%', border: 'none' }}
      />
    );
  }

  if (mimeType.startsWith('image/')) {
    return (
      <img
        src={fileUrl}
        alt={filename}
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    );
  }

  return (
    <DocViewer
      config={{ header: { disableHeader: true } }}
      documents={[{ uri: fileUrl, fileName: filename, fileType: mimeType }]}
      pluginRenderers={DocViewerRenderers}
    />
  );
};

const CustomDocViewer = ({ settings, handleDownload, close, isLoading }) => {
  const { width } = useWindowSize();

  return (
    <Backdrop open sx={{ zIndex: 1310 }}>
      {isLoading ? (
        <CircularProgress sx={{ color: colors.WHITE }} size={60} />
      ) : (
        <>
          <div className={classes.docViewerActions}>
            {width <= responsiveSizeTimesheet && <p className={classes.filename}>{settings.filename}</p>}
            <IconButton onClick={handleDownload}>
              <DownloadIcon
                width={width > responsiveSizeTimesheet ? '25px' : '20px'}
                color={width > responsiveSizeTimesheet ? '' : colors.BLACK_TXT}
              />
            </IconButton>
            <IconButton onClick={close}>
              <CloseButtonIcon
                width={width > responsiveSizeTimesheet ? '25px' : '18px'}
                color={width > responsiveSizeTimesheet ? '' : colors.BLACK_TXT}
              />
            </IconButton>
          </div>

          <div className={classes.docViewerContainer}>
            <SmartRenderer
              base64Data={settings?.data}
              mimeType={getMimeTypeFromDataURI(settings?.data)}
              filename={settings?.filename}
            />
          </div>
        </>
      )}
    </Backdrop>
  );
};

export default CustomDocViewer;